import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcAgeSuitabilityShape, libraryShape } from '@bibliocommons/bc-prop-types';
import Heading from '@bibliocommons/heading';
import CommunityDisclaimer from 'app/components/bibs/shared/ugc/CommunityDisclaimer';
import { AgeRatingEditorContainer } from './AgeRatingEditor';

import './AgeSuitability.scss';

export function AgeSuitability({ currentUserAgeSuitability, summary, metadataId, bibsActions, intl, currentLibrary }) {
  const handleSuccess = () => {
    bibsActions.fetchUGC(metadataId);
  };

  function renderRating(shouldRender, rating) {
    const ratingDisplay = rating === 0 ? intl.formatMessage({ id: 'ugc_age_suitability_age_all' }) : `${rating}+`;
    return (
      <div className="age-rating">
        <span>{shouldRender ? ratingDisplay : '-'}</span>
      </div>
    );
  }

  function renderAverageRating() {
    const total = summary.getIn(['ageSuitabilities', 'total']);
    const average = summary.getIn(['ageSuitabilities', 'average']);

    return (
      <div className="average-rating">
        {renderRating(total, average)}
        <div className="rating-label">
          <FormattedMessage id="age_suitability_average" />
        </div>
        {total ? (
          <div className="total-label">
            <FormattedMessage id="user_contribution_total_count" values={{ count: total }} />
          </div>
        ) : null}
      </div>
    );
  }

  function renderCurrentUserRating() {
    const shouldRender = currentUserAgeSuitability?.size;
    const rating = currentUserAgeSuitability?.get('min') || 0;
    return (
      <div className="current-user-rating">
        {renderRating(shouldRender, rating)}
        <AgeRatingEditorContainer handleSuccess={handleSuccess} />
      </div>
    );
  }

  function renderUgcDisclaimer() {
    return (
      currentLibrary?.get('ugcDisclaimerMessageEnabled') && (
        <CommunityDisclaimer type="suitability" currentLibrary={currentLibrary} />
      )
    );
  }

  return (
    <div className="cp-age-suitability" data-key="age-suitability">
      {renderUgcDisclaimer()}
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="ugc_age_suitability" />
      </Heading>
      <div className="age-suitability-display">
        {renderAverageRating()}
        {renderCurrentUserRating()}
      </div>
    </div>
  );
}

AgeSuitability.propTypes = {
  currentUserAgeSuitability: ugcAgeSuitabilityShape,
  summary: ImmutablePropTypes.map.isRequired,
  metadataId: PropTypes.string.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentLibrary: libraryShape.isRequired
};

export default injectIntl(AgeSuitability);
